import React from 'react';
import { cn } from '@/lib/utils';

interface DarkPanelProps {
  children: React.ReactNode;
  className?: string;
  nested?: boolean;
  padding?: 'sm' | 'md' | 'lg';
  style?: React.CSSProperties;
}

/**
 * DarkPanel - Theme-aware panel container matching design system
 * Background: surface-1 with border-subtle
 * Nested variant: surface-2
 */
export const DarkPanel: React.FC<DarkPanelProps> = ({
  children,
  className,
  nested = false,
  padding = 'md',
  style,
}) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  return (
    <div
      className={cn(
        'border rounded-lg border-border',
        nested ? 'bg-muted/50' : 'bg-card',
        paddingClasses[padding],
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
};






